import React, { useState } from "react";
import PropertyCard from "./PropertyCard";
import "./LandProperties.css";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";

// Land Properties Data - UPDATED WITH areaLocation
const landProperties = [
  {
    id: 107,
    areaLocation: " Gidc Ankleshwar", // ✅ ADDED
    title: " DEMO  Properties => Agricultural Land",
    location: "Mira Nagar, Gidc Ankleshwar",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
    type: "For Sale",
    isFeatured: true,
    imageCount: 6,
    listedDate: "2023-11-15",
    viewCount: 1850,
    propertyType: "land",
    size: "10 Acres",
    amenities: ["Fertile Soil", "Water Well", "Road Access", "Fencing"]
  },
  
];

export default function LandProperties() {
  const [visibleCount, setVisibleCount] = useState(6); // show first 6 properties

  const [viewMode, setViewMode] = useState("grid");
  const [filterType, setFilterType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");

  // ✅ NEW: State for Area Location filter
  const [selectedArea, setSelectedArea] = useState("All");

  // ✅ NEW: Extract unique area locations from landProperties data
  const allAreaLocations = ["All", ...new Set(landProperties
    .map(property => property.areaLocation?.trim())
    .filter(area => area && area.trim() !== "")
    .map(area => area.trim())
  )];

  // Filter properties - BY DEFAULT ONLY LAND ✅
  const filteredProperties = landProperties.filter(property => {
    // ✅ NEW: First apply area location filter (if not 'All')
    if (selectedArea !== "All" && property.areaLocation?.trim() !== selectedArea) {
      return false;
    }

    // ✅ BY DEFAULT: Only land properties

    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        property.size.toLowerCase().includes(searchLower) ||
        (property.amenities && property.amenities.some(amenity =>
          amenity.toLowerCase().includes(searchLower)
        ));

      if (!matchesSearch) return false;
    }

    return true;
  });

  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);
      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleResetFilters = () => {
    setFilterType('all');
    setSearchTerm('');
    setSelectedArea('All'); // ✅ NEW: Reset area filter too
  };

  return (
    <section className="land-section">

      <div className="land-header">
        <div className="land-header-left">
          <h2 className="land-title">Land Properties</h2>
          <p className="land-subtitle">Agricultural, Residential, Commercial & Industrial Plots</p>
        </div>

        <div className="land-header-right">
          <span className="land-count">
            {sortedProperties.length} Land Properties
            {selectedArea !== "All" && ` in ${selectedArea}`} {/* ✅ NEW: Show area if filtered */}
          </span>
        </div>
      </div>

      {/* ✅ NEW: Area Location Filter - Add this ABOVE existing filters */}
      <div className="area-location-filter">
        <h3 className="area-filter-title">Filter by Land Area Location</h3>
        <div className="area-filter-buttons">
          {allAreaLocations.map(area => (
            <button
              key={area}
              className={`area-filter-btn ${selectedArea === area ? 'area-active' : ''}`}
              onClick={() => setSelectedArea(area)}
              type="button"
            >
              {area === "All" ? "All Land Areas" : area}
            </button>
          ))}
        </div>
      </div>

      {/* 🟡 EXISTING: Filters and Controls */}
      <div className="land-controls">
        <div className="land-filter-buttons">
          <button
            className={`land-filter-btn ${filterType === 'all' ? 'land-active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Land
          </button>
          <button
            className={`land-filter-btn ${filterType === 'sale' ? 'land-active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`land-filter-btn ${filterType === 'rent' ? 'land-active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          <div className="land-search-container">
            <FaSearch className="land-search-icon" />
            <input
              type="text"
              placeholder="Search land properties..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="land-search-input"
              aria-label="Search land properties"
            />
            {searchTerm && (
              <button
                className="land-clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className="land-view-controls">
          <div className="land-sort-dropdown">
            <FaSortAmountDown className="land-sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="land-sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
            </select>
          </div>

          <div className="land-view-toggle">
            <button
              className={`land-view-btn ${viewMode === 'grid' ? 'land-active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon */}
            </button>
            <button
              className={`land-view-btn ${viewMode === 'list' ? 'land-active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`land-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} />
        ))}

      </div>

      {visibleCount < sortedProperties.length && (
        <div className="land-view-more-section">
          <button
            className="land-view-more-btn"
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            View More Land Properties
          </button>
        </div>
      )}


      {sortedProperties.length === 0 && (
        <div className="land-no-results">
          <h3>No Land Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="land-reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}
    </section>
  );
}